module.exports = __webpack_public_path__ + "static/5-create-flag-93ce459db824454fff80c33983596b6a.png";